import { useState } from "react";
import { businessInfo, navLinks } from "@/mocks/siteData";

type SiteFooterProps = {
  onOpenConsult: () => void;
};

export default function SiteFooter({ onOpenConsult }: SiteFooterProps) {
  const [bizOpen, setBizOpen] = useState(false);

  return (
    <footer className="border-t border-primary-900/40 bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 pt-14 pb-28 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="font-heading text-2xl font-semibold text-primary-400">Y</span>
              <span className="font-heading text-lg font-semibold text-foreground-950">
                연안<span className="text-primary-400">법무법인</span>
              </span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-foreground-600">
              개인회생·개인파산에 집중하는 도산 전문 조직입니다.
              <br />
              당신의 새로운 시작을 끝까지 함께합니다.
            </p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <button
                type="button"
                onClick={onOpenConsult}
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors duration-300 hover:bg-primary-600 cursor-pointer"
              >
                상담예약
              </button>
              <a
                href="#diagnosis"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-300/60 px-6 py-3 text-sm text-foreground-700 transition-colors duration-300 hover:border-primary-500 hover:text-primary-400 cursor-pointer"
              >
                자가진단
              </a>
            </div>
          </div>

          <div>
            <div className="font-label text-[10px] text-foreground-500">Sitemap</div>
            <div className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3">
              {navLinks.map((link) => (
                <a
                  key={link.id}
                  href={`#${link.id}`}
                  className="text-sm text-foreground-600 transition-colors duration-300 hover:text-primary-400 cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-background-200/60 pt-6">
          <button
            type="button"
            onClick={() => setBizOpen((v) => !v)}
            className="flex items-center gap-2 text-sm text-foreground-600 transition-colors duration-300 hover:text-foreground-900 cursor-pointer"
          >
            사업자 정보
            <i
              className={`ri-arrow-down-s-line transition-transform duration-300 ${
                bizOpen ? "rotate-180" : ""
              }`}
            />
          </button>
          {bizOpen ? (
            <div className="mt-4 space-y-1 text-xs leading-relaxed text-foreground-500 md:text-sm">
              <p>{businessInfo.name}</p>
              <p>{businessInfo.ceo}</p>
              <p>{businessInfo.regNo}</p>
              <p>{businessInfo.address}</p>
              <p>
                대표전화{" "}
                <a
                  href={`tel:${businessInfo.phone.replace(/-/g, "")}`}
                  className="text-primary-400 hover:underline cursor-pointer"
                >
                  {businessInfo.phone}
                </a>
              </p>
            </div>
          ) : null}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-background-200/60 pt-6 text-xs text-foreground-500 sm:flex-row">
          <div className="font-label text-[10px]">
            © 2025 Yeonan Law Firm. All rights reserved.
          </div>
          <div className="flex items-center gap-5">
            <a href="#hero" className="transition-colors duration-300 hover:text-primary-400 cursor-pointer">
              개인정보처리방침
            </a>
            <a href="#hero" className="transition-colors duration-300 hover:text-primary-400 cursor-pointer">
              이용약관
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}